export default __webpack_public_path__ + "static/newyear-6b9899101cb5c919d21cc0ecc180fb14.png";